module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"coach_mark_message":"화면을 위로 밀면<br /> <b>더 많은 리뷰</b>를 확인할 수 있어요","coach_mark_message_pc":"마우스를 스크롤하거나 키보드 방향키 ⬆️⬇️로<br /><b>더 많은 리뷰</b>를 확인할 수 있어요","see_more_reviews":"리뷰 둘러보기"}}')
  delete Component.options._Ctor
}
